export const  EUFY_MEGA = 'eufy_mega'

interface DomainConfig {
  ci: string;
  qa: string;
  eu: string;
  cn: string;
  us: string;
  'eu-qa': string;
}

interface Domains {
  [key: string]: DomainConfig;
}

interface PathConfig {
  [key: string]:string
}

interface Path {
  [key: string]: PathConfig;
}
export const MEGA_DOMAINS:Domains = {
  powermanage: {
    ci: "https://app-powermanage-us-ci.eufylife.com",
    qa: "https://app-powermanage-us-qa.eufylife.com",
    cn: "https://app-powermanage-cn-pr.eufy.com",
    eu: "https://app-powermanage-eu-pr.eufy.com",
    'eu-qa': "https://app-powermanage-eu-qa.eufysecurity.com",
    us: "https://app-powermanage-us-pr.eufy.com"
  },
  pdd: {
    ci: 'https://app-pdd-us-ci.eufylife.com',
    qa: 'https://app-pdd-us-qa.eufylife.com',
    cn: 'https://app-pdd-cn-pr.eufy.com',
    eu: 'https://app-pdd-eu-pr.eufy.com',
    us: 'https://app-pdd-us-pr.eufy.com',
    'eu-qa': 'https://app-pdd-eu-qa.eufysecurity.com',
  },
  push: {
    ci: 'https://app-push-ci.eufylife.com',
    qa: 'https://app-push-us-qa.eufysecurity.com',
    cn: 'https://app-push-cn-pr.eufy.com',
    eu: 'https://app-push-eu-pr.eufy.com',
    us: 'https://app-push-us-pr.eufy.com',
    'eu-qa': 'https://app-push-eu-qa.eufysecurity.com',
  },
  passport: {
    ci: "https://app-passport-us-ci.eufylife.com",
    qa: "https://app-passport-us-qa.eufysecurity.com",
    cn: "https://app-passport-cn-pr.eufy.com",
    eu: "https://app-passport-eu-pr.eufy.com",
    us: "https://app-passport-us-pr.eufy.com",
    'eu-qa': 'https://app-passport-eu-qa.eufy.com',
  },
  house: {
    ci: "https://app-house-us-ci.eufylife.com",
    qa: "https://app-house-us-qa.eufysecurity.com",
    // qa: "https://app-house-eu-qa.eufysecurity.com",

    cn: "https://app-house-cn-pr.eufy.com",
    eu: "https://app-house-eu-pr.eufy.com",
    us: "https://app-house-us-pr.eufy.com",
    'eu-qa': 'https://app-house-eu-qa.eufysecurity.com',
  }
}

export const PATH: Path  = {
  passport: {
     login: '/passport/login',
  }
}